import { Flex, Tag, TagLabel, TagLeftIcon, Text } from "@chakra-ui/react";
import { FormikProps } from "formik";
import { RiLightbulbLine } from "react-icons/ri";
import * as GQL from "src/types/graphql";
import { FormEngineRuleFormData } from "./schemas";

export type RuleTipProps = { formik: FormikProps<FormEngineRuleFormData> };
export const RuleTip: React.FC<RuleTipProps> = ({ formik }) => {
  const tipText = (rule_type: GQL.form_engine_rule_type_enum | undefined) => {
    switch (rule_type) {
      case GQL.form_engine_rule_type_enum.DYNAMIC_SIBLING_TAG: {
        return `The rule will check for these conditions when the form changes sub-status, and when a student is added.

If the condition is not met, and the selected tag is already applied, it will not be removed.`;
      }
      case GQL.form_engine_rule_type_enum.GEOGRAPHIC_PREFERENCE_TAG: {
        return `The rule will check for these conditions when an address changes, and when the form changes status or sub-status.

If the condition is not met, and the selected tag is already applied, it will not be removed.`;
      }
      case GQL.form_engine_rule_type_enum.QUESTION_TAG: {
        return `The rule will check for these conditions when a family submits a response, when the form changes status or sub-status, or when staff saves changed answers.

If the condition is not met, and the selected tag is already applied, it will not be removed.`;
      }
      case GQL.form_engine_rule_type_enum.AUTO_PLACEMENT: {
        return `This rule runs when the form is in a selected status. Submitted is always required. A student is placed at their top ranked school if it has available capacity and carries a selected tag (if set).`;
      }
      case GQL.form_engine_rule_type_enum.AUTO_WAITLIST: {
        return `This rule will run whenever capacity changes. Capacity can change when an offer is declined or revoked, a school is removed from a form response by family or staff, or when the number of Capacity seats is directly increased or reduced by staff.`;
      }
      default: {
        return ``;
      }
    }
  };

  return (
    <Flex
      direction="column"
      gap="0.5rem"
      p="1rem"
      borderTop="1px solid"
      borderTopColor="gray.200"
      borderTopRadius="0"
    >
      <Tag bg="primary.500" color="white" alignSelf="flex-start" size="sm">
        <TagLeftIcon as={RiLightbulbLine} />
        <TagLabel>Tip</TagLabel>
      </Tag>
      <Text whiteSpace="pre-line" fontWeight={"400"}>
        {tipText(formik.values.rule_type)}
      </Text>
    </Flex>
  );
};
